import Months from "./months";
import Years from "./years";

/**
 * Fiscal year (Accounting terminologist)
 * https://en.wikipedia.org/wiki/Fiscal_year
 * calendar yr. for laymans term
 */

const Calendar = {
  Months,
  Years,
};

export default Calendar;
